import React, { createContext, useContext, useState, useCallback, useRef } from 'react';

const LayoutEditContext = createContext(null);

export const LayoutEditProvider = ({ children }) => {
  const [editMode, setEditMode] = useState(false);
  const [saving, setSaving] = useState(false);

  // Registratie van save/cancel handlers door mounted componenten
  // (Dashboard, Sidebar, en later evt. anderen registreren zichzelf)
  const saversRef = useRef(new Map());

  const registerSaver = useCallback((key, handlers) => {
    saversRef.current.set(key, handlers);
    return () => saversRef.current.delete(key);
  }, []);

  const startEdit = useCallback(() => setEditMode(true), []);

  const cancelEdit = useCallback(() => {
    // Alle geregistreerde componenten laten cancellen (eigen state reverten)
    saversRef.current.forEach(h => h.onCancel && h.onCancel());
    setEditMode(false);
  }, []);

  const saveAll = useCallback(async () => {
    setSaving(true);
    try {
      const results = [];
      for (const [key, h] of saversRef.current.entries()) {
        if (h.onSave) {
          try { await h.onSave(); results.push({ key, ok: true }); }
          catch (e) { results.push({ key, ok: false, error: e }); }
        }
      }
      const failed = results.filter(r => !r.ok);
      if (failed.length > 0) {
        alert('Sommige onderdelen niet opgeslagen: ' + failed.map(f => f.key).join(', '));
      }
      setEditMode(false);
    } finally {
      setSaving(false);
    }
  }, []);

  return (
    <LayoutEditContext.Provider value={{
      editMode, saving, startEdit, cancelEdit, saveAll, registerSaver
    }}>
      {children}
    </LayoutEditContext.Provider>
  );
};

export const useLayoutEdit = () => {
  const ctx = useContext(LayoutEditContext);
  if (!ctx) throw new Error('useLayoutEdit must be used within LayoutEditProvider');
  return ctx;
};
